export const BvHiringSteps = [
  {
    name: 'Verificar elegibilidade',
    status: 'done',
  },
  {
    name: 'Fazer simulação',
    status: 'done',
  },
  {
    name: 'Solicitar oferta',
    status: 'done',
  },
  {
    name: 'Aguardar contato do Banco BV',
    status: 'not-started',
  },
  {
    name: 'Enviar documentação',
    status: 'not-started',
  },
  {
    name: 'Fazer vistoria digital',
    status: 'not-started',
  },
  {
    name: 'Aguardar análise',
    status: 'not-started',
  },
  {
    name: 'Liberação do empréstimo',
    status: 'not-started',
  },
]
